import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  contactModalOpen: false,
  offer_type: "",
};

const modalSlice = createSlice({
  name: "modal",
  initialState,
  reducers: {
    openContactModal(state, action) {
      state.contactModalOpen = true;
      state.offer_type = action.payload;
    },
    closeContactModal(state) {
      state.contactModalOpen = false;
    },
  },
});

export const { openContactModal, closeContactModal } = modalSlice.actions;
export default modalSlice.reducer;
